import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

/** 상위품의 바로가기 레이어 styled */
export const ParentChipAnchor = styled(Box, {
  shouldForwardProp: (p) => p !== 'truncated',
})<{ truncated?: boolean }>(({ truncated }) => ({
  position: 'relative',
  display: 'inline-flex',
  alignItems: 'center',
  gap: 5,
  minWidth: 0,
  flex: '0 1 auto',
  overflow: 'visible',
  ...(truncated && { maxWidth: 'calc((100% - 32px) / 2)' }),
}));

export const DropdownRoot = styled('ul')`
  z-index: 50;
  position: absolute;
  left: 20px;
  top: calc(100% + 10px);
  margin: 0;
  padding: 10px 8px;
  min-width: 480px;
  width: max-content;
  max-width: 85vw;
  list-style: none;
  background: var(--dk-bg, #ffffff);
  border-radius: 5px;
  box-shadow: 0px 6px 12px 0px rgba(0, 0, 0, 0.2);

  @media (min-width: 992px) {
    max-width: 50vw;
  }
  @media (min-width: 1600px) {
    max-width: 1150px;
  }
`;

export const DropdownItem = styled('li')`
  margin-top: 8px;

  &:first-of-type {
    margin-top: 0;
  }
`;

export const DropdownItemLink = styled('a')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 8px;
  border-radius: 4px;
  color: var(--dk-text-primary, #333);
  font-family: Pretendard, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 24px;
  text-decoration: none;
  cursor: pointer;

  & > span:last-of-type {
    color: var(--dk-text-secondary, #888d96);
    transition: color 0.15s ease;
  }

  &:hover,
  &:focus-visible {
    background-color: var(--dk-bg-muted, #f3f5f6);
    outline: none;
  }
  &:hover > span:last-of-type,
  &:focus-visible > span:last-of-type {
    color: var(--dk-text, #000);
  }
`;

/** `.parent-item a > span` — 좌측 텍스트, 한 줄 ellipsis */
export const DropdownItemText = styled('span')`
  flex: 1 1 0;
  min-width: 0;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

export const DropdownItemIconWrap = styled('span')`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-left: 8px;

  & > svg {
    width: 12px;
    height: 12px;
  }
`;
